// src/components/CouponToast.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


export default function CouponToast({ coupons, onClose }) {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(onClose, 6000);
    return () => clearTimeout(t);
  }, [onClose]);

  const first = coupons[0];
  const multipleDeals = coupons.length > 1;
  const previewDeals = coupons.slice(0, 3);
  const remainingDeals = coupons.length - previewDeals.length;
  const handleView = (e) => {
    e.stopPropagation();
    navigate(multipleDeals ? '/offers' : `/store/${first.coupon.storeId}`);
    onClose();
  };

  return (
    <div className="coupon-toast" onClick={onClose}>
      <div className="coupon-toast-inner">
        <div className="toast-icon">🏷️</div>
        <div className="toast-body">
          <p className="toast-title">
            {multipleDeals ? 'Deals nearby for you' : <>Deal nearby at <strong>{first.store}</strong>!</>}
          </p>
          {multipleDeals ? (
            <>
              <div className="toast-deal-list">
                {previewDeals.map(({ store, coupon }) => (
                  <p key={coupon.id} className="toast-deal-item">
                    <strong>{store}</strong>: {coupon.title}
                  </p>
                ))}
              </div>
              {remainingDeals > 0 && (
                <p className="toast-more">+{remainingDeals} more deal{remainingDeals > 1 ? 's' : ''} nearby</p>
              )}
            </>
          ) : (
            <p className="toast-desc">{first.coupon.title}</p>
          )}
        </div>
        <button
          className="toast-view-btn"
          onClick={handleView}
        >
          {multipleDeals ? 'View all →' : 'View →'}
        </button>
      </div>
    </div>
  );
}
